import React from 'react'
import { motion, usePresence } from 'motion/react'

const transition = { 
    type: 'spring', 
    stiffness: 1000, 
    damping: 50, 
    mass: 1 
}

function MotionItem({ children, onClick, color, tag_name }) {
    const [isPresent, safeToRemove] = usePresence()
    // console.log('RERENDER ListItem', num)

    const animations = {
        layout: true,
        initial: 'out',
        style: {
        //   color: color.hex(),
        //   position: isPresent ? 'relative' : 'absolute'
        //   position: isPresent ? 'static' : 'absolute'
        },
        animate: isPresent ? 'in' : 'out',
        // whileTap: 'tapped',
        variants: {
        //   in: { scaleY: 1, opacity: 1, zIndex: 0 },
        //   out: { scaleY: 0, opacity: 0, zIndex: -1 },
          in: { scaleY: 1, opacity: 1 },
          out: { scaleY: 0, opacity: 0, transition: { duration: 0.1 } },
        //   exit: { scaleY: 0, opacity: 0 },
        //   tapped: { scale: 0.98, opacity: 0.5, transition: { duration: 0.1 } }
        },
        onAnimationComplete: () => !isPresent && safeToRemove(),
        transition
        
    }

    const Component = motion?.[tag_name] ?? motion.div
    // const Component = motion.div

    return (
        <Component {...animations} className='motion-item' onClick={onClick}>
            {children}
        </Component>
    )
}


export default MotionItem